import { render, staticRenderFns } from "./PeUsers.vue?vue&type=template&id=4b1287ba&scoped=true"
import script from "./PeUsers.vue?vue&type=script&lang=js"
export * from "./PeUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1287ba",
  null
  
)

export default component.exports